import Edit from './edit.vue'
import Show from './show.vue'
export default {
  Show,
  Edit,
  data: {
    data() {
      return {
        data: {},
        render: "UserOrderMenu",
      }
    },
    name: "我的订单",
    icon: "",
  }
}